import React from 'react';
import { useBrandKit } from '../context/BrandKitContext';
import { pickLogo, isLightColor } from '../brandKits';

/**
 * App-chrome logo. When a white-label kit is active the IPM mark is replaced
 * by the client's wordmark; otherwise the standard IPM logo is shown.
 */
export default function BrandLogo({
    variant = 'onDark',
    className,
    style,
    alt,
}) {
    const { kit, active, productName } = useBrandKit();
    const chromeLight = Boolean(active && kit && isLightColor(kit.colors?.chrome || kit.colors?.background));
    const resolvedVariant = variant === 'onDark' && chromeLight ? 'onLight' : variant;
    const src = active && kit ? pickLogo(kit, resolvedVariant) : '/logo-white.png';
    return (
        <img
            src={src}
            alt={alt || productName}
            className={className}
            style={style}
        />
    );
}

export function BrandWordmark({ className, style }) {
    const { active, hideIpm, productName } = useBrandKit();
    if (active && hideIpm) return null;
    return (
        <span className={className} style={style}>
            {active ? productName : 'IPM'}
        </span>
    );
}
